import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import CloseIcon from '../../../../assets/icons/cross.svg';
import EmptyHeight from '../../../../components/EmptyHeight';
import Button, { BUTTON_VARIANTS } from '../../../../ui-kit/Button';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import ArrowIcon from '../../../../assets/icons/tutorialModalArrow.svg';

const ARROW_WIDTH = 18;
const ARROW_HEIGHT = 9;

function TutorialModal({
  x,
  y,
  text,
  arrowPosition,
  arrowX,
  arrowY,
  tutorialStep,
  setTutorialStep,
  setTutorialStage,
  setIsTutorialActive,
  totalSteps,
  withButtons,
  oneButton,
  finishStage1,
  closeTutorials,
}) {
  const { t } = useTranslations();

  const arrowStyles = useMemo(() => {
    if (arrowPosition === 'top') {
      return { top: `${-ARROW_HEIGHT}px`, left: `${arrowX}px` };
    }
    if (arrowPosition === 'bottom') {
      return { bottom: `${-ARROW_HEIGHT}px`, left: `${arrowX}px`, transform: `rotate(${180}deg)` };
    }
    if (arrowPosition === 'left') {
      return { left: `${-ARROW_HEIGHT - 2}px`, top: `${arrowY}px`, transform: `rotate(${270}deg)` };
    }
    if (arrowPosition === 'right') {
      return { right: `${-ARROW_HEIGHT - 2}px`, top: `${arrowY}px`, transform: `rotate(${90}deg)` };
    }
    return { display: 'none' };
  }, [arrowPosition, arrowX, arrowY]);

  const onCloseClick = () => {
    closeTutorials();
  };

  const onBackClick = () => {
    if (tutorialStep > 1) setTutorialStep((prev) => prev - 1);
  };

  const onNextClick = () => {
    if (tutorialStep < totalSteps) setTutorialStep((prev) => prev + 1);
    else {
      finishStage1();
    }
  };

  return (
    <div className={classNames(styles.tutorialModal, { [styles.tutorialModalLong]: withButtons })} style={{ left: `${x}px`, top: `${y}px` }}>
      <div
        onClick={onCloseClick}
        className={classNames(styles.closeButton, 'pressable')}
      >
        <img src={CloseIcon} alt="X" />
      </div>
      <p className={styles.text}>{text}</p>

      <EmptyHeight height={20} />
      <div className={styles.dots}>
        {new Array(totalSteps).fill(0).map((_, i) => (
          <div key={i} className={classNames(styles.dot, { [styles.dotActive]: i < tutorialStep })} />
        ))}
      </div>
      <EmptyHeight height={20} />

      {withButtons && (
        <div className={styles.buttonsRow}>
          {!oneButton && (
            <div className={styles.button}>
              <Button
                text={t(DICTIONARY.back)}
                variant={BUTTON_VARIANTS.secondary}
                onClick={onBackClick}
                width="100%"
                isDisabled={tutorialStep === 1}
              />
            </div>
          )}
          <div className={styles.button}>
            <Button
              text={oneButton ? t(DICTIONARY.ok) : t(DICTIONARY.next)}
              onClick={onNextClick}
              width="100%"
            />
          </div>
        </div>
      )}

      {/* Arrow Start */}
      <div className={styles.arrow} style={arrowStyles}>
        <img src={ArrowIcon} alt="A" />
      </div>
      {/* Arrow End */}
    </div>
  );
}

export default TutorialModal;
